import { createContext } from "react";

export const VishcorpPricingContext = createContext();
